import styled from 'styled-components';

import { device, hexToRGB, screen } from '@/styles/helpers';

export const ScMenu = styled.ul`
  list-style: none;
  display: flex;
  flex-wrap: nowrap;
  overflow: hidden;
  justify-content: flex-start;
  align-items: center;
  margin-left: 32px;
  overflow-y: auto;
  position: relative;
  gap: 8px;

  @media (${device.desktop}) {
    margin-left: 16px;
  }

  @media (${device.tablet}) {
    flex-direction: column;
    gap: 8px;
    margin: 16px 0 0;
  }

  & > li.menu-wide-only {
    display: none;

    @media (${screen.xxl}) {
      display: list-item;
    }
  }

  & > li {
    position: relative;
    & > button {
      border: none;
      background: none;
    }

    @media (${device.tablet}) {
      width: 100%;
      border: 1px solid rgba(255, 255, 255, 0.2);
      border-radius: 12px;
      padding: 15px 12px 15px 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .notification {
      content: "";
      position: absolute;
      right: 36px;
      width: 8px;
      height: 8px;
      top: 50%;
      transform: translateY(-50%);
      background-color: ${({ theme }) => theme.error};
      border-radius: 50%;
    }

    & > a,
    & > button {
      display: flex;
      justify-content: center;
      align-items: center;
      color: ${({ theme }) => theme.whiteColor};
      text-decoration: none;
      text-transform: uppercase;
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.01em;
      position: relative;
      height: 35px;
      transition: color 0.3s;
      width: 100%;

      @media (${device.desktop}) {
        &.de {
          padding: 0px 4px;
        }
      }

      @media (${device.tablet}) {
        justify-content: flex-start;
        font-size: 16px;
        line-height: 20px;
        padding: 0;
        height: auto;
      }

      i {
        position: relative;
        margin: 0 8px;
        z-index: -1;
        font-weight: 400;
        transition: fill 0.3s;

        @media (${device.tablet}) {
          margin-left: 0;
        }
      }

      @media (hover: hover) {
        &:hover {
          color: ${({ theme }) => theme.mainColor};

          @media (${device.mobile}) {
            color: ${({ theme }) => theme.whiteColor};
          }

          i {
            color: ${({ theme }) => theme.mainColor};
          }
        }
      }
    }

    &.active > a,
    &.active > button {
      color: ${({ theme }) => theme.mainColor};

      i {
        color: ${({ theme }) => theme.mainColor};

        &:first-child {
          color: ${({ theme }) => theme.mainColor};
        }
      }
    }

    .arrow {
      flex-shrink: 0;
      width: 16px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`;

export interface ScStripeProps {
  stripeWidth: number;
  stripeLeft: number;
}

export const ScStripe = styled.div<ScStripeProps>`
  position: absolute;
  left: ${({ stripeLeft }) => `${stripeLeft}px`};
  width: ${({ stripeWidth }) => `${stripeWidth}px`};
  bottom: 0;
  height: 2px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.mainColor};
  transition: 0.6s;
`;

export const ScMenuMore = styled.li<{ $isActive: boolean }>`
  && > button {
    display: flex;
    align-items: center;
    height: 35px;
    padding: 0 4px;
    color: ${({ theme, $isActive }) =>
      $isActive ? theme.mainColor : theme.whiteColor};
    font-size: 18px;
    font-weight: 700;
    line-height: 18px;
    cursor: pointer;
    transition: color 0.3s;

    @media (hover: hover) {
      &:hover {
        color: ${({ theme }) => theme.mainColor};
      }
    }
  }

  @media (${screen.xxl}) {
    display: none;
  }
`;

interface ScMenuMoreDropdownProps {
  $top: number;
  $left: number;
}

export const ScMenuMoreDropdown = styled.ul<ScMenuMoreDropdownProps>`
  position: fixed;
  top: ${({ $top }) => $top}px;
  left: ${({ $left }) => $left}px;
  transform: translateX(-50%);
  z-index: 16;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 185px;
  padding: 16px;
  border-radius: 19px;
  background-color: ${({ theme }) => theme.grayLightColor};
  box-shadow: 0 2px 10px ${({ theme }) => hexToRGB(theme.blackColor, 0.9)};
  list-style: none;

  & > li > a {
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.whiteColor};
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0.01em;
    text-decoration: none;
    text-transform: uppercase;
    white-space: nowrap;
    transition: color 0.3s;
  }

  & > li.active > a {
    color: ${({ theme }) => theme.mainColor};
  }

  @media (hover: hover) {
    & > li > a:hover {
      color: ${({ theme }) => theme.mainColor};
    }
  }
`;
